import GetOffset from '../_utils/GetOffset';
import SmoothScroll from '../_utils/SmoothScroll';

export default class HeroHome {


	// Constructor
	constructor(element) {
		this.element = element;

		this.scrollMin = -1;
		//this.scrollMax = -1;

		this.updateBelowTimer = null;
		this.updateBelow = this.updateBelow.bind(this);

		this.scrollLink = this.element.querySelector('.section-hero-home--link');
		this.scrollLink.addEventListener('click', this.scrollToVideo.bind(this));

		this.videoContainer = this.element.querySelector('.section-hero-home--video');
		this.videoButton = this.videoContainer.querySelector('button');
		this.videoButton.addEventListener('click', this.videoButtonClick.bind(this));
		this.video = this.videoContainer.querySelector('video:not([autoplay])');
		this.video.addEventListener('play', this.videoPlay.bind(this));
		this.video.addEventListener('pause', this.videoPause.bind(this));
		this.video.addEventListener('ended', this.videoPause.bind(this));


	}


	// Public Methods
	resize() {
		const elementTop = GetOffset.top(this.videoContainer);
		const elementHeight = this.videoContainer.offsetHeight;
		const windowHeight = window.innerHeight;

		//const elementAppear = elementTop - windowHeight;
		//const elementDisappear = elementTop + elementHeight;
		const elementIsInCenter = elementTop - ((windowHeight - elementHeight) / 2);

		this.scrollMin = elementIsInCenter - (elementHeight / 2);
		//this.scrollMax = elementIsInCenter + (elementHeight / 2);

		this.scroll();
	}
	scroll() {
		if (this.scrollMax !== -1 && this.scrollMin !== -1) {
			const scrollY = window.pageYOffset;
			//if (scrollY <= this.scrollMax && scrollY >= this.scrollMin) {
			if (scrollY >= this.scrollMin) {
				if (this.updateBelowTimer === null && this.videoContainer.classList.contains('in-view') === false) {
					this.updateBelowTimer = setTimeout(this.updateBelow, 1000);
				}
				this.videoContainer.classList.add('in-view');
			} else {
				this.videoContainer.classList.remove('in-view');
			}
		}
	}


	// Event Handlers
	scrollToVideo(event) {
		event.preventDefault();
		const y = this.videoContainer.getBoundingClientRect().top + window.pageYOffset;
		SmoothScroll(y, 500, null);
		this.video.play();
	}
	videoButtonClick(event) {
		event.preventDefault();
		this.video.play();
	}
	videoPlay() {
		this.videoButton.style.display = 'none';
		this.video.classList.add('state-playing')
	}
	videoPause() {
		this.videoButton.style.display = 'block';
		this.video.classList.remove('state-playing')
	}
	updateBelow() {
		this.updateBelowTimer = null;
		window.dispatchEvent(new Event('resize'));
	}


}
